import { createAction, props } from '@ngrx/store';
import { LoadingInfo } from '../../../api';
export enum ProductPageActionTypes {
  Clear = '[ProductPage] Clear',

  GetUserSettings = '[Products Page] Get User Settings',
  GetUserSettingsSuccess = '[Products Page] Get User Settings Success',
  GetUserSettingsFail = '[Products Page] Get User Settings Fail',

  SetFiltersPreferences = '[Dashboard Page] Set Products Filters Preferences',

  SetTableState = '[Products Page] Set Table State',

  SetUserSettings = '[Products Page] Set User Settings',
  SetUserSettingsSuccess = '[Products Page] Set User Settings Success',
  SetUserSettingsFail = '[Products Page] Set User Settings Fail',

  SetLatestSearchId = '[Products Page] Set Latest Search Id',

  ResetFilters = '[Products Page] Reset Filters'
}

export const clear = createAction(ProductPageActionTypes.Clear);

export const setTableState = createAction(ProductPageActionTypes.SetTableState, props<{ tableState: LoadingInfo }>());

export const getUserSettings = createAction(ProductPageActionTypes.GetUserSettings, props<{ versionFlag: string }>());
export const getUserSettingsSuccess = createAction(ProductPageActionTypes.GetUserSettingsSuccess, props<{ settings: Record<string, any> }>());
export const getUserSettingsFail = createAction(ProductPageActionTypes.GetUserSettingsFail, props<{ error: Error }>());

export const setUserSettings = createAction(ProductPageActionTypes.SetUserSettings, props<{ settings: Record<string, any>; versionFlag: string }>());
export const setUserSettingsSuccess = createAction(
  ProductPageActionTypes.SetUserSettingsSuccess,
  props<{ settings: Record<string, any>; shouldNavigate?: boolean }>()
);
export const setUserSettingsFail = createAction(ProductPageActionTypes.SetUserSettingsFail, props<{ error: Error }>());

export const setFiltersPreferences = createAction(ProductPageActionTypes.SetFiltersPreferences, props<{ filtersPreferences: Pick<LoadingInfo, 'filters'> }>());

export const setLatestSearchId = createAction(ProductPageActionTypes.SetLatestSearchId, props<{ searchId: number }>());

export const resetFilters = createAction(ProductPageActionTypes.ResetFilters);
